// Per conventions/code-standards.md ("Error classes carry a name property") and
// languages/typescript.md ("Error classes — minification-safe name"): a per-class
// `static readonly errorName` string literal, copied onto `this.name` in the constructor, so the
// identity survives both JSON serialization and minification.
export class AppInitError extends Error {
    static readonly errorName: string = 'AppInitError';

    constructor(message: string) {
        super(message);
        this.name = AppInitError.errorName;
    }
}
